<template>
  <div>
		<ModalBackground v-if="isMenu" @closeMenu="closeMenu"/>
		<Menu :isMenu="isMenu" @closeMenu="closeMenu"/>
  </div>
</template>

<script>
import ModalBackground from '@/components/LP/atoms/ModalBackground'
import Menu from '@/components/LP/molecules/Menu'

export default {
	name: 'SlideMenu',
	components: {
		ModalBackground,
		Menu
  },
  props: {
    isMenu: {
      type: Boolean,
      required: false
    }
  },
  methods: {
    closeMenu (bool) {
      this.$emit('closeMenu', bool)
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/LP/organisms/SlideMenu.vue